import { getLanguageCodeByLocale } from 'common/enums/LanguageCodeEnum'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import FieldErrors from 'publisher/components/FieldErrors'
import { typedPageSelectors, useOptIn, usePage } from 'publisher/store'
import { getCustomerCountry } from 'publisher/store/optIn/optInSelectors'
import React from 'react'
import { FieldIconNew } from 'src/shared/components/field-icon-new'
import { FieldWrapper } from 'src/shared/components/field-wrapper'
import { PhoneInputProps } from 'src/shared/components/phone-input'
import { PhoneNumberFieldNew } from 'src/shared/components/phone-number-field-new'
import { ContactUsFieldEntityInterface } from 'src/shared/entities/contact-us-field/contact-us-field-entity.schema'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'
import { FieldSubEntityInterface } from 'src/shared/schemas/fields/field-sub-entity.schema'

export interface BasePublisherPhoneNumberFieldProps {
  entity:
    | FieldEntityInterface
    | ContactUsFieldEntityInterface
    | FieldSubEntityInterface
  value: string | undefined
  onChange: (value: string) => void
  errors: string[]
  isHidden?: boolean
}

export const BasePublisherPhoneNumberField = ({
  entity,
  value,
  onChange,
  errors,
  isHidden,
}: BasePublisherPhoneNumberFieldProps) => {
  const locale = usePage(typedPageSelectors.getLocale)

  const customerCountry = useOptIn(getCustomerCountry) || undefined

  const handlePhoneNumber: PhoneInputProps['onChange'] = ({
    unformatedPhone,
  }) => {
    onChange(unformatedPhone)
  }

  return (
    <StyleWrapper
      id={entity.htmlAttrId}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      {typeof window !== 'undefined' && !isHidden && (
        <FieldWrapper>
          {entity.iconClassName && (
            <FieldIconNew
              color={entity.color}
              mobileColor={entity.mobileColor}
              fontSize={entity.fontSize}
              mobileFontSize={entity?.mobileFontSize}
              className={entity.iconClassName}
            />
          )}
          <PhoneNumberFieldNew
            initialCountry={customerCountry?.toLowerCase()}
            value={value || ''}
            onChange={handlePhoneNumber}
            hasIcon={!!entity.iconClassName}
            hasErrors={!!errors.length}
            textAlign={entity.textAlign}
            mobileTextAlign={entity.mobileTextAlign}
            padding={entity.padding}
            mobilePadding={entity.mobilePadding}
            border={entity.border}
            mobileBorder={entity.mobileBorder}
            backgroundColor={entity.backgroundColor}
            mobileBackgroundColor={entity.mobileBackgroundColor}
            color={entity.color}
            mobileColor={entity.mobileColor}
            placeholder={entity.placeholder}
            placeholderColor={entity.placeholderColor}
            mobilePlaceholderColor={entity.mobilePlaceholderColor}
            fontSize={entity.fontSize}
            mobileFontSize={entity.mobileFontSize}
            lineHeight={entity.lineHeight}
            mobileLineHeight={entity.mobileLineHeight}
            boxShadow={entity.boxShadow}
            mobileBoxShadow={entity.mobileBoxShadow}
            countrySelectorStyleProps={{
              dropdownStyleProps: {
                style: { fontSize: entity.fontSize },
                searchInputStyle: { fontSize: entity.fontSize },
              },
            }}
            countrySelectorProps={{
              language: getLanguageCodeByLocale(locale),
            }}
          />
        </FieldWrapper>
      )}
      <FieldErrors errors={errors} />
    </StyleWrapper>
  )
}
